














  import {Component, Prop, Vue} from 'vue-property-decorator'
  import ModalPopup from '@/components/dialogs/ModalPopup.vue'
  import Button from '@/components/buttons/Button.vue'

  @Component({
  components: {
    ModalPopup,
    Button,
  },
})

export default class PanelDeleteConfirmPopUp extends Vue {
  @Prop(String) public panelName!: string

  public close() {
    this.$emit('close')
  }

  public confirm() {
    this.$emit('confirm')
    this.$emit('close')
  }
}
